// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getAbilityById } from 'app/constants/enums/Ability/main';

/* eslint-disable max-len */
export const ADMIN_BOT_BOOKINGS_ABILITY = getAbilityById('adminBotBookings');
export const ADMIN_MEETING_BOOKINGS_ABILITY = getAbilityById('adminMeetingBookings');
export const ANSWER_SOCIAL_QUESTION_ABILITY = getAbilityById('answerSocialQuestion');
export const AUTHORIZE_EDITORS_ABILITY = getAbilityById('authorizeEditors');
export const AUTHORIZE_MANAGERS_ABILITY = getAbilityById('authorizeManagers');
export const AUTHORIZE_SITE_CONTENT_ABILITY = getAbilityById('authorizeSiteContent');
export const AUTHORIZE_TEACHERS_ABILITY = getAbilityById('authorizeTeachers');
export const AUTOMATIC_CALL_RECORDING_ABILITY = getAbilityById('automaticCallRecording');
export const CREATE_MEETING_BOOKINGS_ABILITY = getAbilityById('createMeetingBookings');
export const CREATE_ORGANIZATIONS_ABILITY = getAbilityById('createOrganizations');
export const CREATE_OTHER_USERS_ABILITY = getAbilityById('createOtherUsers');
export const DELETE_ORGANIZATIONS_ABILITY = getAbilityById('deleteOrganizations');
export const DELETE_USERS_ABILITY = getAbilityById('deleteUsers');
export const DO_RTC_CUSTOMER_SUPPORT_ABILITY = getAbilityById('doRtcCustomerSupport');
export const EDIT_BANNER_ABILITY = getAbilityById('editBanner');
export const EDIT_BLOCKED_EMAIL_DOMAINS_ABILITY = getAbilityById('editBlockedEmailDomains');
export const EDIT_CATEGORIES_ABILITY = getAbilityById('editCategories');
export const EDIT_COMMON_TEXT_ABILITY = getAbilityById('editCommonText');
export const EDIT_DIALOG_SPEAKER_ABILITY = getAbilityById('editDialogSpeaker');
export const EDIT_DICTIONARY_CONTENT_ABILITY = getAbilityById('editDictionaryContent');
export const EDIT_LESSON_ABILITY = getAbilityById('editLesson');
export const EDIT_LESSON_BOOKING_RECORDINGS_ABILITY = getAbilityById('editLessonBookingRecordings');
export const EDIT_LESSON_BOOKINGS_ABILITY = getAbilityById('editLessonBookings');
export const EDIT_LESSON_TRANSLATION_ABILITY = getAbilityById('editLessonTranslation');
export const EDIT_MY_ACCOUNT_ABILITY = getAbilityById('editMyAccount');
export const EDIT_ORGANIZATIONS_ABILITY = getAbilityById('editOrganizations');
export const EDIT_ROOM_PERSISTENCE_ABILITY = getAbilityById('editRoomPersistence');
export const EDIT_SITE_STRINGS_ABILITY = getAbilityById('editSiteStrings');
export const EDIT_SOCIAL_QUESTION_ABILITY = getAbilityById('editSocialQuestion');
export const EDIT_TEACHERS_ABILITY = getAbilityById('editTeachers');
export const EDIT_TEMPLATE_ABILITY = getAbilityById('editTemplate');
export const EDIT_USER_BRAND_ABILITY = getAbilityById('editUserBrand');
export const EDIT_USERS_ABILITY = getAbilityById('editUsers');
export const MANAGE_STAFF_ABILITY = getAbilityById('manageStaff');
export const PUBLISH_LESSON_ABILITY = getAbilityById('publishLesson');
export const REPORT_ISSUE_ABILITY = getAbilityById('reportIssue');
export const RETRIEVE_BULK_EMAIL_ABILITY = getAbilityById('retrieveBulkEmail');
export const RETRIEVE_RAW_RTC_PERSISTENCE_ABILITY = getAbilityById('retrieveRawRtcPersistence');
export const TEACH_LESSON_ABILITY = getAbilityById('teachLesson');
export const TRANSLATE_DICTIONARY_CONTENT_ABILITY = getAbilityById('translateDictionaryContent');
export const UPLOAD_RECORDING_ABILITY = getAbilityById('uploadRecording');
export const USE_ALPHA_FEATURES_ABILITY = getAbilityById('useAlphaFeatures');
export const USE_RESERVED_FEATURES_ABILITY = getAbilityById('useReservedFeatures');
export const VIEW_LESSON_BOOKING_RECORDINGS_ABILITY = getAbilityById('viewLessonBookingRecordings');
export const VIEW_LESSON_BOOKING_TRANSCRIPTS_ABILITY = getAbilityById('viewLessonBookingTranscripts');
export const VIEW_LESSON_BOOKINGS_ABILITY = getAbilityById('viewLessonBookings');
export const VIEW_MEETING_BOOKING_RECORDINGS_ABILITY = getAbilityById('viewMeetingBookingRecordings');
export const VIEW_ORGANIZATIONS_ABILITY = getAbilityById('viewOrganizations');
export const VIEW_SERVER_STATS_ABILITY = getAbilityById('viewServerStats');
export const VIEW_TEACHERS_ABILITY = getAbilityById('viewTeachers');
export const VIEW_USER_PROFILES_ABILITY = getAbilityById('viewUserProfiles');
export const VIEW_USERS_ABILITY = getAbilityById('viewUsers');
/* eslint-enable max-len */
